import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import { GlobalStyle } from './styles/GlobalStyle';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileMenu from './components/MobileMenu';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import SubCategoryPage from './pages/SubCategoryPage';
import ArticlePage from './pages/ArticlePage';
import ArticleListPage from './pages/ArticleListPage';
import CountryArticlesPage from './pages/CountryArticlesPage';
import { ArticleProvider } from './contexts/ArticleContext';
import { initGA, sendPageView, trackReferrer } from './utils/analytics';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

const App: React.FC = () => {
  // Google Analytics初期化
  useEffect(() => {
    // Google Analytics初期化
    initGA();
    
    // 初回ページビュー送信
    sendPageView(window.location.pathname + window.location.search);
    
    // リファラー情報をトラッキング
    trackReferrer();
    
    // ページビュー追跡のためのカスタムイベントを設定
    const handleNavigationChange = () => {
      sendPageView(window.location.pathname + window.location.search);
    };
    
    // 履歴変更をリッスン
    window.addEventListener('popstate', handleNavigationChange);
    
    // React RouterのLink要素クリックを監視（カスタムイベント）
    const originalPushState = window.history.pushState;
    window.history.pushState = function() {
      // @ts-ignore
      const result = originalPushState.apply(this, arguments);
      // カスタムイベント発火
      window.dispatchEvent(new Event('locationchange'));
      return result;
    };
    
    // カスタムイベントのリスナーを追加
    window.addEventListener('locationchange', handleNavigationChange);
    
    return () => {
      window.removeEventListener('popstate', handleNavigationChange);
      window.removeEventListener('locationchange', handleNavigationChange);
      window.history.pushState = originalPushState;
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ArticleProvider directory="/articles">
        <Router>
          <AppContainer>
            <Header />
            <MobileMenu />
            <MainContent>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/category/:categoryName" element={<CategoryPage />} />
                <Route path="/category/:categoryName/:subCategoryName" element={<SubCategoryPage />} />
                <Route path="/article/:slug" element={<ArticlePage />} />
                <Route path="/article" element={<ArticleListPage />} />
                <Route path="/articles" element={<ArticleListPage />} />
                <Route path="/country/:countryName" element={<CountryArticlesPage />} />
              </Routes>
            </MainContent>
            <Footer />
          </AppContainer>
        </Router>
      </ArticleProvider>
    </ThemeProvider>
  );
};

export default App;
